<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">投票规则</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button type="primary" @click="editRule(null)">新增规则</el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button type="primary" @click="copyRule()" plain>
            拷贝规则
          </el-button>
          <el-button type="primary" @click="editRule(null)">新增规则</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane
          :disabled="tableLoading"
          v-for="rootRule in rootRuleList"
          :key="rootRule.Type"
          :label="rootRule.Name"
          :name="rootRule.Type"
        ></el-tab-pane>
      </el-tabs>
      <el-table
        v-loading="tableLoading"
        :data="ruleTableList"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column property="Name" label="规则名称"> </el-table-column>
        <el-table-column
          label="通过方式"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 0"
          key="PassOperatorText"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.PassOperatorText }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="通过率"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 0"
          key="PassValue"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.PassValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="去掉最高分"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 2"
          key="DeleteMaxScore"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.DeleteMaxScore">是</span>
            <span v-if="!scope.row.DeleteMaxScore">否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="去掉最低分"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 2"
          key="DeleteMinScore"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.DeleteMinScore">是</span>
            <span v-if="!scope.row.DeleteMinScore">否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="显示评委信息"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 3"
          key="IsAnony"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.IsAnony">是</span>
            <span v-if="!scope.row.IsAnony">否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否去掉最高分"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 3"
          key="IsRemoveMaxScore"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.IsRemoveMaxScore">是</span>
            <span v-if="!scope.row.IsRemoveMaxScore">否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否去掉最低分"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 3"
          key="IsRemoveMinScore"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.IsRemoveMinScore">是</span>
            <span v-if="!scope.row.IsRemoveMinScore">否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否分细项打分"
          width="120"
          align="center"
          v-if="parseInt(activeName) === 3"
          key="IsDetailRule"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.IsDetailRule">是</span>
            <span v-if="!scope.row.IsDetailRule">否</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="50" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="225">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              v-if="parseInt(activeName) === 2"
              @click.stop
              @click="ruleItemManager(scope.row.Id)"
            >
              细则管理
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="parseInt(activeName) === 3 && scope.row.IsDetailRule"
              @click.stop
              @click="ruleItemManager(scope.row.Id)"
            >
              细则管理
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="parseInt(activeName) === 0 || parseInt(activeName) === 2"
              @click.stop
              @click="editRuleDetails(scope.row.Id)"
            >
              介绍
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editRule(scope.row.Id)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteRule(scope.row)"
              v-if="scope.row.VoteNames.length === 0"
            >
              删除
            </el-link>
            <el-popover placement="left" width="400" trigger="hover">
              <el-table :data="scope.row.VoteNames">
                <el-table-column width="400" label="被以下投票使用">
                  <template slot-scope="scope1">
                    <span>{{ scope1.row }}</span>
                  </template></el-table-column
                >
              </el-table>
              <el-link
                title="被以下投票使用"
                type="primary"
                class="cell_link"
                slot="reference"
                v-if="scope.row.VoteNames.length !== 0"
                :disabled="scope.row.VoteNames.length !== 0"
              >
                删除
                <i class="el-icon-connection el-icon--right"></i>
              </el-link>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="ruleListQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="ruleTotalCount"
        >
        </el-pagination>
      </div>
      <EditRule
        :meetId="meetingId"
        :ruleType="parseInt(activeName)"
        :fatherSubmitDialog="submitRuleDialog"
        ref="editRule"
      ></EditRule>
      <EditRuleDetails ref="editRuleDetails"></EditRuleDetails>
      <EditRuleItems ref="editRuleItems"></EditRuleItems>
      <CopyRule
        :fatherSubmitDialog="submitRuleDialog"
        ref="copyRule"
      ></CopyRule>
    </div>
  </div>
</template>
<script>
import voteRuleApi from '../../../api/vote/voteRule'
import EditRule from '@/components/rule/EditRule.vue'
import EditRuleDetails from '@/components/rule/EditRuleDetails.vue'
import EditRuleItems from '@/components/rule/EditRuleItems.vue'
import CopyRule from '@/components/rule/CopyRule.vue'
export default {
  name: 'Home',
  components: {
    EditRule,
    EditRuleDetails,
    EditRuleItems,
    CopyRule
  },
  data () {
    return {
      pagination_layout: 'prev, pager, next',
      meetingId: null,
      activeName: 0,
      tableLoading: true,
      rootRuleList: [],
      ruleTableList: [],
      ruleTotalCount: 0,
      currentPage: 1,
      ruleListQuery: {
        meetingId: null,
        ruleType: 0,
        maxResultCount: 10,
        skipCount: 0
      }
    }
  },
  methods: {
    getRootRules: function () {
      this.tableLoading = true
      voteRuleApi.getRootRules().then(data => {
        this.rootRuleList = data
        this.getRules()
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    tabClick (tab, event) {
      this.tableLoading = true
      this.currentPage = 1
      this.ruleListQuery.skipCount = 0
      this.ruleListQuery.ruleType = parseInt(this.activeName)
      this.ruleTableData = []
      switch (tab.name) {
        case '0':
          this.getRules()
          break
        case '2':
          this.getRules()
          break
        case '3':
          this.getScreenRules()
          break
      }
    },
    getScreenRules: function () {
      this.tableLoading = true
      voteRuleApi.getScreenRules({
        meetingId: this.ruleListQuery.meetingId,
        ruleType: this.ruleListQuery.ruleType,
        skipCount: this.ruleListQuery.skipCount,
        maxResultCount: this.ruleListQuery.maxResultCount
      })
        .then(data => {
          this.ruleTableList = data.Items
          this.ruleTotalCount = data.TotalCount
          this.tableLoading = false
        }).catch(err => {
          this.tableLoading = false
          return err
        })
    },
    getRules: function () {
      this.tableLoading = true
      voteRuleApi.getRules({
        meetingId: this.ruleListQuery.meetingId,
        ruleType: this.ruleListQuery.ruleType,
        skipCount: this.ruleListQuery.skipCount,
        maxResultCount: this.ruleListQuery.maxResultCount
      })
        .then(data => {
          this.ruleTableList = data.Items
          this.ruleTotalCount = data.TotalCount
          this.tableLoading = false
        }).catch(err => {
          this.tableLoading = false
          return err
        })
    },
    indexMethod (index) {
      return this.ruleListQuery.skipCount + index + 1
    },
    handleSizeChange (val) {
      this.ruleListQuery.maxResultCount = val
      if (parseInt(this.activeName) === 3) {
        this.getScreenRules()
      } else {
        this.getRules()
      }
    },
    handleCurrentChange (val) {
      this.ruleListQuery.skipCount = (val - 1) * this.ruleListQuery.maxResultCount
      if (parseInt(this.activeName) === 3) {
        this.getScreenRules()
      } else {
        this.getRules()
      }
    },
    editRule: function (ruleId) {
      this.$refs.editRule.openEditRule(ruleId)
    },
    copyRule: function () {
      this.$refs.copyRule.openCopyRule(this.meetingId)
    },
    submitRuleDialog: function () {
      if (parseInt(this.activeName) === 3) {
        this.getScreenRules()
      } else {
        this.getRules()
      }
    },
    deleteRule: function (ruleItem) {
      this.$confirm('确认删除规则“' + ruleItem.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteRuleApi.deleteRule({
          ruleId: ruleItem.Id
        }).then(data => {
          openLoading.close()
          if (parseInt(this.activeName) === 3) {
            this.getScreenRules()
          } else {
            this.getRules()
          }
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editRuleDetails: function (ruleId) {
      this.$refs.editRuleDetails.openEditRule(ruleId)
    },
    ruleItemManager: function (ruleId) {
      this.$refs.editRuleItems.openEditRuleItems(ruleId)
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.ruleListQuery.meetingId = this.$route.params.mid
    this.getRootRules()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
